// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { calendarCheckLines16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-calendar-check-lines': IconCalendarCheckLines;
    }
}

/**
 * The icon component for the 'calendarCheckLines' icon
 */
export class IconCalendarCheckLines extends IconSvg {
    public constructor() {
        super(calendarCheckLines16X16);
    }
}

registerIconSvg('icon-calendar-check-lines', IconCalendarCheckLines);
export const iconCalendarCheckLinesTag = 'nimble-icon-calendar-check-lines';
